import { Button } from "@chakra-ui/react"
import withTranslate from "@pathwright/ux/src/components/lng/withTranslate"
import classnames from "classnames"
import isFunction from "lodash/isFunction"
import React, { useContext, useState } from "react"
import Pathicon from "../pathicon/Pathicon"
import "./Gates.css"

export const GatesContext = React.createContext()

export const useGatesContext = () => useContext(GatesContext)

const Gates = ({ children, heading, className, t }) => {
  const [SelectedGate, setSelectedGate] = useState(null)

  if (SelectedGate) {
    return (
      <div className={classnames("Gates__selected", className)}>
        <Button
          variant="subtle"
          colorScheme="gray"
          size="xs"
          onClick={(e) => {
            setSelectedGate(null)
          }}
        >
          <Pathicon icon="arrow-left" />
          {t("gates.back")}
        </Button>
        {isFunction(SelectedGate) ? <SelectedGate /> : SelectedGate}
      </div>
    )
  }

  return (
    <GatesContext.Provider
      value={{
        setSelectedGate
      }}
    >
      <div className={classnames("Gates", className)}>
        {heading}
        {children && <div className="Gates__wrapper">{children}</div>}
      </div>
    </GatesContext.Provider>
  )
}

Gates.displayName = "Gates"

export default withTranslate(Gates)
